
<ng-container *ngIf="!isTextArea && !maxDigits" [formGroup]="formParent">
    <div class="input-group" [ngClass]="{'has-error': control?.dirty && control?.invalid}">
        <label [for]="frmControl">{{ label }}</label>
        <div class="input-wrapper">
            <input
                [type]="type"
                [id]="frmControl"
                [formControlName]="frmControl"
                [placeholder]="placeholder"
                (blur)="focusOutInput()"
                (focus)="focusInput()"
                (keyup)="keyupInput($event)"
                autocomplete="off"
                [readonly]="isReadOnly"
                [ngClass]="{'input-error': control?.dirty && control?.invalid}"
                #inputElement
            />
            <!-- Ícono del ojo para contraseñas -->
 
            <span  *ngIf="frmControl === 'password' || frmControl === 'currentPassword' || frmControl === 'passwordConfirm' || frmControl === 'confirmPassword' || frmControl === 'lastpassword' || frmControl === 'newpassword'" class="toggle-password" (click)="togglePassword()">
                <!-- Ícono Ojo Abierto -->
                
                <!-- <svg  xmlns="http://www.w3.org/2000/svg" width="24px" height="24px" viewBox="0 0 576 512" fill="currentColor">
                    <path d="M572.52 241.4C518.3 135.9 410.88 64 288 64S57.7 135.9 3.48 241.4a32.35 32.35 0 0 0 0 29.1C57.7 376.1 165.12 448 288 448s230.3-71.9 284.52-177.5a32.35 32.35 0 0 0 0-29.1zM288 400c-99.8 0-192.3-56.3-238.23-144C95.7 168.3 188.2 112 288 112s192.3 56.3 238.23 144C480.3 343.7 387.8 400 288 400zm0-272a128 128 0 1 0 128 128 128.14 128.14 0 0 0-128-128zm0 208a80 80 0 1 1 80-80 80.1 80.1 0 0 1-80 80z"/>
                </svg> -->
                <svg *ngIf="type === 'password' " class="eye-icon" width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M1 12C1 12 5 4 12 4C19 4 23 12 23 12C23 12 19 20 12 20C5 20 1 12 1 12Z" stroke="#807F7E" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                    <path d="M12 15C13.6569 15 15 13.6569 15 12C15 10.3431 13.6569 9 12 9C10.3431 9 9 10.3431 9 12C9 13.6569 10.3431 15 12 15Z" stroke="#807F7E" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                </svg>
                    
        
                <!-- Ícono Ojo Cerrado -->
                <!-- <svg *ngIf="type !== 'password' " xmlns="http://www.w3.org/2000/svg" width="26px" height="18px" viewBox="0 0 585 506" fill="currentColor">
                    <path d="M38.8 5.1C28.4-3.1 13.3-1.2 5.1 9.2S-1.2 34.7 9.2 42.9l592 464c10.4 8.2 25.5 6.3 33.7-4.1s6.3-25.5-4.1-33.7L525.6 386.7c39.6-40.6 66.4-86.1 79.9-118.4c3.3-7.9 3.3-16.7 0-24.6c-14.9-35.7-46.2-87.7-93-131.1C465.5 68.8 400.8 32 320 32c-68.2 0-125 26.3-169.3 60.8L38.8 5.1zM223.1 149.5C248.6 126.2 282.7 112 320 112c79.5 0 144 64.5 144 144c0 24.9-6.3 48.3-17.4 68.7L408 294.5c8.4-19.3 10.6-41.4 4.8-63.3c-11.1-41.5-47.8-69.4-88.6-71.1c-5.8-.2-9.2 6.1-7.4 11.7c2.1 6.4 3.3 13.2 3.3 20.3c0 10.2-2.4 19.8-6.6 28.3l-90.3-70.8zM373 389.9c-16.4 6.5-34.3 10.1-53 10.1c-79.5 0-144-64.5-144-144c0-6.9 .5-13.6 1.4-20.2L83.1 161.5C60.3 191.2 44 220.8 34.5 243.7c-3.3 7.9-3.3 16.7 0 24.6c14.9 35.7 46.2 87.7 93 131.1C174.5 443.2 239.2 480 320 480c47.8 0 89.9-12.9 126.2-32.5L373 389.9z"/>
                </svg> -->

                <svg *ngIf="type !== 'password' " class="eye-icon" width="24px" height="24px" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" transform="rotate(0) scale(1, 1)">
                <g clip-path="url(#clip0_7227_8941)">
                <path d="M9.9 4.24C10.5883 4.07888 11.2931 3.99834 12 4C19 4 23 12 23 12C22.393 13.1356 21.6691 14.2047 20.84 15.19M14.12 14.12C13.8454 14.4147 13.5141 14.6512 13.1462 14.8151C12.7782 14.9791 12.3809 15.0673 11.9781 15.0744C11.5753 15.0815 11.1752 15.0074 10.8016 14.8565C10.4281 14.7056 10.0887 14.481 9.80385 14.1962C9.51897 13.9113 9.29439 13.5719 9.14351 13.1984C8.99262 12.8248 8.91853 12.4247 8.92563 12.0219C8.93274 11.6191 9.02091 11.2218 9.18488 10.8538C9.34884 10.4859 9.58525 10.1546 9.88 9.88M1 1L23 23M17.94 17.94C16.2306 19.243 14.1491 19.9649 12 20C5 20 1 12 1 12C2.24389 9.6819 3.96914 7.65661 6.06 6.06L17.94 17.94Z" stroke="#7e7f81" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                </g>
                <defs>
                <clipPath id="clip0_7227_8941">
                <rect width="24" height="24" fill="#ffffff"/>
                </clipPath>
                </defs>
                </svg>
            </span>




        </div>
    </div>
</ng-container>
<ng-container *ngIf="!isTextArea && maxDigits" [formGroup]="formParent">
    <div class="input-group" [ngClass]="{'has-error': control?.dirty && control?.invalid}">
        <label [for]="frmControl">{{ label }}</label>
        <input            
            [type]="type"
            [id]="frmControl"
            [formControlName]="frmControl"
            [placeholder]="placeholder"
            (blur)="focusOutInput()"
            (focus)="focusInput()"
            (keyup)="keyupInput($event)"
            autocomplete="off"
            oninput="javascript: if (this.value.length > this.maxLength) this.value = this.value.slice(0, this.maxLength);"
            [maxlength]="maxDigits"
            [readonly]="isReadOnly"
            [ngClass]="{'input-error': control?.dirty && control?.invalid}"
            #inputElement
        />        
    </div>
</ng-container>
<ng-container *ngIf="isTextArea" [formGroup]="formParent">
    <div class="input-group" [ngClass]="{'has-error': control?.dirty && control?.invalid}">
        <label [for]="frmControl">{{ label }}</label>
        <textarea            
            [id]="frmControl"
            [formControlName]="frmControl"
            [placeholder]="placeholder"
            (blur)="focusOutInput()"
            (focus)="focusInput()"
            (keyup)="keyupInput($event)"
            [readonly]="isReadOnly"
            [ngClass]="{'input-error': control?.dirty && control?.invalid}"
            #inputElement
        ></textarea>        
    </div>
</ng-container>

<ng-container *ngIf="control?.dirty && control?.invalid">
    <span class="help-block" *ngFor="let errorMessage of control['errorMessages']"> {{errorMessage}} <br></span>
    <span class="help-block" *ngIf="control.errors.async"> {{control.errors.async}} </span>
</ng-container>
